import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { closeAblyConnection, createAblyClient } from "./config";
import { STORAGE_KEY } from "@/constant/export/storage";
import { GlobalAppEventType } from "@/constant/export/GlobalAppEventType";
import { useSelector } from "react-redux";
import type { RootState } from "@/store/store";

const AblyContext = createContext<null | any>(null);

export const useAbly = () => useContext(AblyContext);

export const AblyProvider = ({ children }: any) => {
  const clientId = useSelector((state: RootState) =>
    state.userDetail ? `hpoll-user--${state.userDetail.id}` : null
  );

  // useEffect(() => {
  //   const handleClientIdUpdate = (event: any) => {
  //     setClientId(event.detail);
  //   };

  //   window.addEventListener(
  //     GlobalAppEventType.WS_CLIENT_ID_UPDATED,
  //     handleClientIdUpdate
  //   );

  //   return () => {
  //     window.removeEventListener(
  //       GlobalAppEventType.WS_CLIENT_ID_UPDATED,
  //       handleClientIdUpdate
  //     );
  //   };
  // }, []);

  const ablyClient = useMemo(() => {
    if (clientId) {
      return createAblyClient(clientId);
    }
    return null;
  }, [clientId]);

  useEffect(() => {
    if (ablyClient) {
      ablyClient.connection.once("connected", () => {
        console.debug("[Ably] Connection established");
      });

      ablyClient.connection.on("failed", (stateChange) => {
        console.error("[Ably] Connection failed", stateChange);

        if (stateChange.reason?.code === 40140) {
          closeAblyConnection(ablyClient);
        }
      });

      return () => {
        closeAblyConnection(ablyClient);
      };
    }
  }, [ablyClient]);

  return (
    <AblyContext.Provider value={ablyClient}>{children}</AblyContext.Provider>
  );
};

export { AblyContext };
